import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=e55d1178&lang=scss&scoped=true"

import exportComponent from "/Users/a123/Desktop/代码/易考通相关项目/证书查询/zs-query/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e55d1178"]])

export default __exports__